import React from 'react';
import { Box } from '@mui/material';
//
import General from 'components/form/publisher/tabs/General';
import Title from 'components/common/Title';
import { useParams } from 'react-router-dom';
import { EditFormContainer } from 'components/common/Containers';
import { useHasPermissions } from 'hooks/useHasPermissions';
import { PERMISSIONS } from '../../constants';

const CreatePublisher = () => {
  const { id } = useParams();
  const canEditPublisher = useHasPermissions(PERMISSIONS.PUBLISHERS_MANAGEMENT);

  return (
    <EditFormContainer>
      <Box>
        <Title>Publishers Info</Title>
      </Box>
      <General id={id} editable={canEditPublisher} />
    </EditFormContainer>
  );
};

export default CreatePublisher;
